import React, { useState } from "react";
import { useParams } from "react-router-dom";
import useServiceDetails from "../../../Hooks/useServiceDetails";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../../firebase.init";
import axios from "axios";
import { toast } from "react-toastify";

const Checkout = () => {
  const { serviceId } = useParams();
  const [service] = useServiceDetails(serviceId);
  const [user] = useAuthState(auth);
  console.log(user);

  // const [user, setUser] = useState({
  //     name: 'Akbar the Great',
  //     email: 'Akbar@hoassanin.com',
  //     address: 'MomtajMohol _ md.pur',
  //     cell: '01764646414654'
  // })

  // const handleAddressChange = event => {
  //     console.log(event.target.value);
  //     const {address, ...rest} = user;
  //     const newAddress = event.target.value;
  //     const newUser = {address: newAddress, ...rest};
  //     console.log(address, rest);
  //     setUser(newUser);
  // }

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    const order = {
      user: user.email,
      service: service.name,
      serviceId: serviceId,
      address: event.target.address.value,
      phone: event.target.cell.value,
    };
    axios
      .post("https://secret-wildwood-00894.herokuapp.com/order", order)
      .then((response) => {
        const { data } = response;
        if (data.insertedId) {
          toast("Your account is book");
          event.target.reset();
        }
      });
  };

  return (
    <div>
      <h2 className="text-center mt-5">
        Please Checkout :{" "}
        <span style={{ color: "indianred" }}>{service.name}</span>{" "}
      </h2>
      <form
        onSubmit={handlePlaceOrder}
        className="w-50 mx-auto p-5 my-5 shadow rounded"
        action=""
      >
        <input
          className="w-100 p-2 "
          type="text"
          name="name"
          value={user.displayName}
          placeholder="Name"
          required
          readOnly
          disabled
        />
        <br />
        <br />
        <input
          className="w-100 p-2 "
          type="text"
          value={user.email}
          name="email"
          placeholder="Email"
          required
          readOnly
          disabled
        />
        <br />
        <br />
        <input
          className="w-100 p-2 "
          type="text"
          name="service"
          value={service.name}
          required
          readOnly
        />
        <br />
        <br />
        <input
          className="w-100 p-2 "
          type="text"
          value={user.address}
          name="address"
          placeholder="Address"
          autoComplete="off"
          required
        />
        <br />
        <br />
        <input
          className="w-100 p-2 "
          type="text"
          value={user.cell}
          name="cell"
          placeholder="Cell"
          required
        />
        <br />
        <br />
        <img className="border" src={user.photoURL} alt="" />
        <br />
        <br />
        <input
          className="btn btn-primary w-100 p-2 "
          type="submit"
          value="Submit"
        />
      </form>
    </div>
  );
};

export default Checkout;
